import { ajax } from "../../app/core/ajax";
import { alert } from "../core/alert";
import { ll } from "../core/ll";
import { popUp } from "./popUp";

export interface DeletePopUpOptions {
    friendlyEntityName: string;
    ajax?: () => JQueryPromise<any>;
    deleteMessage?: string;
    deleteMessageParameter?: string;
    actions?: string[];
    onDelete?: (e: any) => void;
    onCancel?: (e: any) => void;
}

export function deletePopUp(options: DeletePopUpOptions) {
    const instance = popUp({
        id: "DeletePopUp",
        title: ll("DeleteTitle").format(ll(options.friendlyEntityName)),
        guts: options.deleteMessage ?
                options.deleteMessageParameter ?
                    ll(options.deleteMessage).format(options.deleteMessageParameter)
                    : ll(options.deleteMessage)
            : ll("DeleteMessage").format(ll(options.friendlyEntityName)),
        width: 650,
        keepContentBox: true,
        actions: options.actions,
        buttons: [
            {
                name: "Yes",
                id: "DeleteYes",
                clickEvent: e => {
                    e.preventDefault();
                    if (options.ajax) {
                        return options.ajax().done(() => {
                            alert({
                                header: ll("DeleteSuccess"),
                                message: ll("DeleteSuccessMessage").format(ll(options.friendlyEntityName)),
                                type: "success"
                            });
                            options.onDelete && options.onDelete(e);
                        }).fail(() => {
                            alert({
                                header: ll("DeleteFailed"),
                                message: ll("DeleteFailMessage").format(ll(options.friendlyEntityName)),
                                type: "danger"
                            });
                        }).always(() => {
                            instance.window.close();
                        });
                    } else {
                        options.onDelete && options.onDelete(e);
                    }
                }
            },
            {
                name: "No",
                clickEvent: e => {
                    options.onCancel && options.onCancel(e);
                }
            }
        ],
        close: e => {
            options.onCancel && options.onCancel(e);
        }
    });

    return instance;
}
